import { FSAccessoryData, mapFSAccessoryDatas } from "../Accessory/AccessoryData";
import { FSColor, mapFSColor } from "../Color";
import { FSFileList, mapFSFileLists } from "../FileList";
import { FSDataOrder, mapFSDataOrder } from "../Order";
import { FSType, mapFSType } from "../Type";
import { FSTileShop, mapFSTileShop } from "./TileShop";

/* **************************************************** Finishing Shedule Tile Data */
export interface FSTileData {
    id: number;
    fs_data_id: number;
    type_id: number | null;
    shop_id: number | null;
    color_id: number | null;
    name: string | null;
    link: string | null;
    quantity: number | null;
    size: number | null;
    image_path: string | null;
    file_list: FSFileList[];
    order_status: 'Pending' | 'Ordered' | 'Instore' | 'Onsite';
    order_date_data: string | null;
    order_date: string | null;
    order_data: FSDataOrder | null;
    type: FSType | null;
    shop: FSTileShop | null;
    color: FSColor | null;
}

export const mapFSTileData = (data: any): FSTileData => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSTileData = {
        id: data.id,
        fs_data_id: data.fs_data_id,
        type_id: data.type_id || null,
        shop_id: data.shop_id || null,
        color_id: data.color_id || null,
        name: data.name || null,
        link: data.link || null,
        quantity: data.quantity || null,
        size: data.size || null,
        image_path: data.image_path || null,
        file_list: Array.isArray(data.file_list) ? mapFSFileLists(data.file_list) : [],
        order_status: data.order_status,
        order_date_data: data.order_date_data || null,
        order_date: data.order_date || null,
        order_data: data.order_data ? mapFSDataOrder(data.order_data) : null,
        type: data.type ? mapFSType(data.type) : null,
        shop: data.shop ? mapFSTileShop(data.shop) : null,
        color: data.color ? mapFSColor(data.color) : null,
    };

    return res;
};

export const mapFSTileDatas = (data: any[]): FSTileData[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSTileData);
};


/* **************************************************** Finishing Shedule Tile */
export interface FSTile {
    id: number;
    fs_feature_id: number;
    category: string | null;
    location_name: string | null;
    location_id: number | null;
    is_default_feature: 1 | 0;
    data_tile: FSTileData[];
    data_accessory: FSAccessoryData[];
}

export const mapFSTile = (data: any): FSTile => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSTile = {
        id: data.id,
        fs_feature_id: data.fs_feature_id,
        category: data.category || null,
        location_name: data.location_name || null,
        location_id: data.location_id || null,
        is_default_feature: data.is_default_feature,
        data_tile: Array.isArray(data.data_tile) ? mapFSTileDatas(data.data_tile) : [],
        data_accessory: Array.isArray(data.data_accessory) ? mapFSAccessoryDatas(data.data_accessory) : [],
    };

    return res;
};

export const mapFSTiles = (data: any[]): FSTile[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSTile);
};
